
import {Component, Vue} from 'vue-property-decorator';
import myHeader from '@/components/Header.vue';

import {getFileList, getQinToken, postFileList} from "@/api/courseWork/myHomework/answerSheet";

@Component({
  components: {
    myHeader,
  }
})
export default class RacticeReport extends Vue {
  fileList = [];
  showFrom = false;
  recticPe = {};
  shHash = {1: '待审核', 3: '审核未通过', 2: '审核通过'};

  created() {
    this.getData();

  };

  handleRemove(file: File, fileList: any) {
    console.log(file, fileList);
  };

  handlePreview(file: File) {
    console.log(file);
  };

  handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  };


  handleChange(file: File, fileList: any) {
    this.fileList = fileList.slice(-3);
  };

  beforeUpload(file: File) {
    const allowedTypes = [
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/pdf' // .pdf
    ];

    // 检查文件类型是否符合要求
    const isTypeValid = allowedTypes.includes(file.type);

    if (!isTypeValid) {
      this.$message.error('文件类型错误，仅支持Word和PDF格式！');
      return false; // 阻止上传
    }
    return true;
  };

  postflie() {
    postFileList({'file': this.fileList}).then((res: any) => {
      if (res.code == 200) {
        this.$message.success('提交成功，等待审核');
        this.getData();
      } else {
        this.$message.error(res.msg);
      }
    });
  };

  getData() {
    getFileList({}).then((res: any) => {
      this.showFrom = res.stu_rep;
      this.recticPe = res.data;

    });
  };

  editShowFrom() {
    this.showFrom = false;
  };
}
